import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScreensState } from '../reducers/screens.reducer';

export const screensState: any = createFeatureSelector<ScreensState>('screens');

export const appNav = createSelector(screensState, (state: any) => {
  //console.log(state);
  return state.appNavStructure;
});

export const screenProps = createSelector(screensState, (state: any) => {
  //console.log(state);
  return state.screenProps;
});

export const allScreens = createSelector(screensState, (state: any) => state.selectedScreens);

export const updatedScreenData = createSelector(screensState, (state: any) => state.results);
export const allIdMaps = createSelector(screensState, (state: any) => state.idMaps);

export const newScreen = createSelector(screensState, (state: any) => state.addedScreen);

export const selectedScreen = createSelector(screensState, (state: any) => state.selectedScreenStructure);

export const fiForSelectedScreen = createSelector(screensState, (state: any) => state.fieldsInfo);

export const deletedScreenId = createSelector(screensState, (state: any) => state.deletedScreenId);

export const childTables = createSelector(screensState, (state: any) => state.childTables);

export const errorFlag = createSelector(screensState, (state: any) => state.errorData);

export const landScrId = createSelector(screensState, (state: any) => state.landScrId);

export const confAndFileCntntSveSucc = createSelector(screensState, (state: any) => {
  return state.results;
});

export const confAndFileCntntSveFail = createSelector(screensState, (state: any) => {
  return state.error;
});

export const tableOrder = createSelector(screensState, (state: any) => state.tableOrder);

export const queryPages = createSelector(screensState, (state: any) => state.queryPages);

export const queryTables = createSelector(screensState, (state: any) => state.queryTables);

export const queryTableData = createSelector(screensState, (state: any) => state.queryTableData);

export const standardPages = createSelector(screensState, (state: any) => state.standardPages);

export const tableData = createSelector(screensState, (state: any) => state.tableData);
export const msScreenData = createSelector(screensState, (state: any) => state.msScreenData);
export const setPageVariables = createSelector(screensState, (state: any) => state.setPageVariablesData);
export const deletePageVariableSuccess = createSelector(
  screensState,
  (state: any) => state.deletePageVariableSuccessData
);
export const savePageVariableSuccess = createSelector(screensState, (state: any) => state.savePageVariableSuccessData);
export const queryMapData = createSelector(screensState, (state: any) => state.queryMapData);
